import { cn } from '@shared/components/shadcn';
import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';
import { HomeWinnersStoriesAnimatedStack } from './components/HomeWinnersStoriesAnimatedStack';
import { HomeWinnersStoriesCta } from './components/HomeWinnersStoriesCta';
import type { HomeWinnersStoryConfig } from './types';

type HomeWinnersStoriesSectionProps = ComponentProps<'section'> & {
  namespace: string;
  stories: ReadonlyArray<HomeWinnersStoryConfig>;
  ctaHref: string;
  headingId?: string;
};

function HomeWinnersStoriesSection({ namespace, stories, ctaHref, headingId = 'home-winners-stories-heading', className, ...props }: HomeWinnersStoriesSectionProps) {
  const t = useTranslations(namespace);

  if (stories.length === 0) return null;

  return (
    <section
      aria-labelledby={headingId}
      className={cn(
        'light flex flex-col items-start gap-5 rounded-2xl border-2 border-border-active bg-accent-green p-5 shadow-foreground shadow-[0_3px_0_0] md:hidden',
        className
      )}
      data-testid="home-winners-stories-section"
      data-track-container="Winners Stories"
      {...props}
    >
      <h2 id={headingId} className="heading-4 text-foreground">
        {t('title')}
      </h2>
      <HomeWinnersStoriesAnimatedStack namespace={namespace} stories={stories} data-testid="home-winners-stories-mobile-stack" />
      <div data-track-container="Actions">
        <HomeWinnersStoriesCta href={ctaHref} label={t('cta')} data-testid="home-winners-stories-cta-mobile" />
      </div>
    </section>
  );
}

export { HomeWinnersStoriesSection, type HomeWinnersStoriesSectionProps };
